/*!
 */

;(function ($, window, document, undefined) {

  var pluginName = 'beLanding',
    defaults = {
      propertyName: "value"
    };

  // The actual plugin constructor
  function Plugin(element, options) {
    this.element = element;
    this.$element = $(element);

    this.options = $.extend({}, defaults, options);

    this._defaults = defaults;
    this._name = pluginName;

    this.init();
  }

  Plugin.prototype.init = function () {

    var Plugin = this;

    $.views.settings.delimiters("[[", "]]");

    window.setAnimatedInputs();

    Plugin.setModuleEvents();

    $('.select').select2({
      allowClear: true,
      dropdownCssClass: 'no-search'
    });

    Plugin.watchModuleSelect();
    Plugin.duplicateFields();
    Plugin.removeFields();
    Plugin.duplicateComponents();
  };

  Plugin.prototype.watchModuleSelect = function () {

    var Plugin = this;

    Plugin.$element.find('.js-autocomplete__add').on('click', function (e) {
      e.preventDefault();
      var selected = Plugin.$element.find('.js-autocomplete-modules').val();
      Plugin.getModuleData(selected);
    });
  };

  Plugin.prototype.duplicateComponents = function () {
    var Plugin = this;

    Plugin.$element.find('.js-duplicate-modules').on('click', function (e) {
      e.preventDefault();
      var selected = Plugin.$element.find('.js-master--landings').val();
      var selectedDynamicPageId = $(this).attr('data-dynamic-page-id');

      $.post(window.location.origin + '/landings/duplicate/' + selected, {
        dynamicPageId: selectedDynamicPageId
      }).success(function () {
        location.reload();
      })
        .error(function (data) {
          console.info(data);
        })
    });
  }

  Plugin.prototype.duplicateFields = function () {
    var Plugin = this;

    Plugin.$element.find('.js-multiple_fields_add').on('click', function (e) {
      e.preventDefault();
      var addButtonClicked = e.target;
      var selectedId = addButtonClicked.getAttribute('data-id');
      Plugin.getComponentData(selectedId, addButtonClicked);
    });
  }

  Plugin.prototype.getModuleData = function ($id) {

    var Plugin = this;

    $.ajax({
      url: window.location.origin + '/modules/get/' + $id,
      success: function (data) {
        Plugin.printModuleForm(data);
      },
      error: function (data) {
        console.info(data);
      },
    });
  };

  Plugin.prototype.getComponentData = function ($id, addButtonClicked) {
    var Plugin = this;

    $.ajax({
      url: window.location.origin + '/modules/get/' + $id,
      success: function (data) {
        Plugin.printComponentsForm(data, addButtonClicked);
      },
      error: function (data) {
        console.info(data);
      },
    });
  }

  Plugin.prototype.printModuleForm = function (data) {
    var Plugin = this;

    data = JSON.parse(data);

    $.get(window.location.origin + '/modules/module-template', {
      moduleId: $('#select-module').val()
    }).success(function (tmp) {

      var template = $.templates(tmp);

      var tmpHtml = template.render(data);

      Plugin.$element.find('.js-beLanding__modules').append(tmpHtml);

      Plugin.setModuleEvents();

      Plugin.initSummernote();

      window.setAnimatedInputs();

      $('.select').select2({
        allowClear: true,
        dropdownCssClass: 'no-search'
      });

      Plugin.duplicateFields();

    });
  };

  Plugin.prototype.printComponentsForm = function (data, addButtonClicked) {
    var Plugin = this;
    var moduleId = addButtonClicked.getAttribute('data-moduleId')

    data = JSON.parse(data);

    $.get(window.location.origin + '/modules/module-fields-template', {
      moduleTemplateId: addButtonClicked.getAttribute('data-id'),
      moduleId: addButtonClicked.getAttribute('data-moduleId')
    }).success(function (tmp) {

      var template = $.templates(tmp)

      var tmpHtml = template.render(data);

      if (moduleId !== null) {
        Plugin.$element.find('.js-beLanding__module__multiple_fields\\[' + moduleId + '\\]').append(tmpHtml);
      } else {
        Plugin.$element.find('.js-beLanding__module__multiple_fields\\[\\]').append(tmpHtml);
      }

      Plugin.initSummernote();
      window.setAnimatedInputs();
      Plugin.removeFields();

    });
  }

  Plugin.prototype.setModuleEvents = function () {
    $('.js-beLanding__module .close').on('click', function () {
      $(this).parents('.js-beLanding__module').remove();
    });
  };

  Plugin.prototype.removeFields = function () {
    var Plugin = this;

    Plugin.$element.find('.js-beLanding--fields_remove').on('click', function () {
      $(this).closest('.js-beLanding-removable-fields').remove();
    });
  }

  Plugin.prototype.initSummernote = function () {
    var summernoteFonts = ['Muli', 'Helvetica Neue', 'Helvetica', 'Roboto', 'Arial', 'sans-serif', 'Gotham-Dark', 'Montserrat-Bold', 'Montserrat-Dark', 'Rustico-Regular', 'Rubik-Dark', 'Rubik-Regular', 'Bariol-Regular', 'Georgia-Regular', 'Lato-Regular', 'Santander-Regular', 'Futura-Regular'];

    $('.summernote').summernote({
      height: 200,
      defaultFontName: 'Muli',
      fontNames: summernoteFonts,
      fontNamesIgnoreCheck: summernoteFonts,
      fontSizes: ['8', '9', '10', '11', '12', '13', '14', '16', '18', '20', '22', '24', '36', '48'],
      lineHeight: '120%',
      toolbar: [
        ['color', ['color']],
        ['insert', ['link']],
        ['style', ['bold', 'italic', 'underline', 'clear']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['fontsize', ['fontsize']],
        ['fontname', ['fontname']],
      ],
      callbacks: {
        onPaste: function (e) {
          var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
          e.preventDefault();
          document.execCommand('insertText', false, bufferText);
        }
      }
    });
  }

  // A really lightweight plugin wrapper around the constructor,
  // preventing against multiple instantiations
  $.fn[pluginName] = function (options) {
    return this.each(function () {
      if (!$.data(this, 'plugin_' + pluginName)) {
        $.data(this, 'plugin_' + pluginName,
          new Plugin(this, options));
      }
    });
  }

})(jQuery, window, document);
